export const enum FieldName {
  Code = 'code',
  Pin = 'pin',
}
